import { createComponent } from '@carvana/merch-components';
import {
  CommonSection,
  ContentContainer
} from '~/components/flp/Financing.styles';

export const ShopTermsSection = createComponent(CommonSection, {
  className: 'pt-0'
});

export const Container = createComponent(ContentContainer, {
  className:
    'flex flex-col sm:flex-grow sm:flex-row sm:justify-center sm:gap-2xl'
});

export const ShopTermsCard = createComponent('div', {
  className:
    'flex flex-col gap-2xl py-4xl sm:w-1/2 sm:gap-4xl sm:rounded-xl sm:border sm:border-solid sm:border-border-weak sm:px-2xl md:px-4xl'
});

export const Heading = createComponent('div', {
  className: 'flex flex-col gap-md'
});

export const HeadingTitle = createComponent('h2', {
  className: 'text-text-strong t-heading-2xl'
});

export const HeadingDescription = createComponent('p', {
  className: 'text-text-default t-body-lg'
});
